module.exports = __webpack_public_path__ + "static/media/3 06 Tulleord Flynt er feil-norming.1b4ff913.mp3";